import { Copy, CopyCheck } from 'lucide-react';
import { MouseEvent, useState } from 'react';
import IconButton from 'src/shared/components/ui/buttons/icon-button';
import { cn } from 'src/shared/lib/utils';

type CopyButtonProps = {
  value: string;
  variant?: 'default' | 'subtle';
  className?: string;
  testId?: string;
};

export default function CopyButton({ value, variant = 'default', className, testId }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  function handleCopy(e: MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 5000);
  }

  if (variant === 'subtle') {
    return (
      <button
        disabled={!value}
        onClick={handleCopy}
        data-testid={testId}
        className={cn(
          'shrink-0 disabled:opacity-50 disabled:pointer-events-none',
          !copied ? 'hover:text-neutral-800 text-neutral-400 transition-all' : ' ',
          className
        )}
      >
        {!copied ? <Copy size={12} /> : <CopyCheck size={12} className="text-success hover:text-success-800" />}
      </button>
    );
  }

  return (
    <IconButton
      icon={copied ? 'CopyCheck' : 'Copy'}
      variant={copied ? 'success' : 'light'}
      onClick={handleCopy}
      data-testid={testId}
    />
  );
}
